module.exports = __webpack_public_path__ + "static/media/full-light.61386a73.svg";